// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39auX","name":"styles_name__2dWFi","phone":"styles_phone__3qasp"};